import { graphql } from 'gql.tada';

export const accountQuery = graphql(`
  query Account {
    account {
      email
      lockeId
      phoneNumberVerified
      phoneNumber
    }
  }
`);
